import { createFileRoute } from '@tanstack/react-router';

import { pageAndSortSearchShape } from '../modules/ComponentsLibrary/AdvancedSearch/listState';
import { UnifiedJobSearch } from '../modules/ComponentsLibrary/AdvancedSearch/UnifiedJobSearch';
import { unifiedJobSearchScheme } from '../modules/ComponentsLibrary/AdvancedSearch/UnifiedJobSearch/utils';

export const Route = createFileRoute('/jobs-unified')({
  component: RouteComponent,
  head() {
    return {
      meta: [{ title: 'Job Search' }],
    };
  },
  validateSearch: unifiedJobSearchScheme.extend(pageAndSortSearchShape),
});

function RouteComponent() {
  return (
    <div className="theme-light min-h-screen bg-white">
      <UnifiedJobSearch accounting={false} showJob showExport />
    </div>
  );
}
